import WysiwygBlock from '../blocks/WysiwygBlock';

type FaqItemProps = {
    id: number | string
    index: number
    question: string
    answer: string
    isLast?: boolean
    isOpen: boolean
    handleToggle: (index: number) => void
  }
  export const FaqItem = (props: FaqItemProps) => {
    const { index, question, answer, isLast = false, isOpen, handleToggle, id} = props;
  
      return (
        <>
            <div className={`collapse collapse-plus ${isOpen ? 'collapse-open' : 'collapse-close'}`}>
              <input
                type="checkbox"
                name={`faq-accordion-${id}`}
                onChange={() => handleToggle(index)}
              />
              <div className="collapse-title text-xl font-medium pr-24">
                <h3 className="text-sm font-bold text-justify">{question}</h3>
              </div>
              <div className="collapse-content text-sm pr-24 text-justify">
                <WysiwygBlock html={answer} styles='text-justify'/>
              </div>
            </div>
        </>
      );
  };

export default FaqItem;